import React, { useState } from 'react';
import Header from './Header';
import MobileSidebar from './MobileSidebar';
import SiteFooter from './SiteFooter';

interface PublicLayoutProps {
  children: React.ReactNode;
  footer?: boolean;
}

export default function PublicLayout({ children, footer = true }: PublicLayoutProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="pub-page">
      <Header
        onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
        showMobileMenu={mobileMenuOpen}
      />
      <MobileSidebar
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
      {children}
      {footer && <SiteFooter />}
    </div>
  );
}
